import axios from 'axios';
import { API } from '../constants/Constants';
import {
  getLocalStorageItem,
  removeLocalStorageItem,
  setLocalStorageItem,
} from './localStorageUtils';
import Toast from '../components/pages/utils/Toast';

let accessToken;
function getLocalAccessToken() {
  return getLocalStorageItem('AccessToken');
}

function getLocalSessionId() {
  return getLocalStorageItem('SessionId');
}

function getLocalUserId() {
  return getLocalStorageItem('UserId');
}

function getLocalRefreshToken() {
  return getLocalStorageItem('RefreshToken');
}

async function refreshToken() {
  try {
    const accessTokenCheck = getLocalStorageItem('AccessToken');
    const refreshTokenCheck = getLocalStorageItem('RefreshToken');
    const sessionIdCheck = getLocalStorageItem('SessionId');
    if (accessTokenCheck && refreshTokenCheck && sessionIdCheck) {
      return await axios.post(`${API.REFRESH_TOKEN}`, {
        refreshToken: getLocalRefreshToken(),
        sessionId: getLocalSessionId(),
        userId: getLocalUserId(),
      });
    }
  } catch (error) {
    if (error?.response?.data?.statusCode === 403) {
      Toast({
        message: `${error.response.data.message}`,
        variant: 'info',
      });
      removeLocalStorageItem('RefreshToken');
      removeLocalStorageItem('AccessToken');
      removeLocalStorageItem('role');
      removeLocalStorageItem('SessionId');
      removeLocalStorageItem('UserId');
      window.location.href = '/login';
    }
  }
}

const Instance = axios.create({
  // baseURL: APP_URL,
  // timeout: 10000,0
  headers: { Authorization: `Bearer ${accessToken}` },
});

Instance.interceptors.request.use(
  (config) => {
    const token = getLocalAccessToken();
    if (token) {
      const updatedConfig = { ...config };
      updatedConfig.headers.Authorization = `Bearer ${token}`;
      return updatedConfig;
    }
    return config;
  },
  (error) => Promise.reject(error),
);

Instance.interceptors.response.use(
  (res) => res,
  async (err) => {
    const originalConfig = err.config;

    if (err.response) {
      if (err.response.status === 419 && !originalConfig._retry) {
        originalConfig._retry = true;
        removeLocalStorageItem(accessToken);
        try {
          const rs = await refreshToken();
          if (rs && rs?.data) {
            const accessTokenAfterExpired = rs?.data?.accessToken;

            setLocalStorageItem('AccessToken', accessTokenAfterExpired);
            Instance.defaults.headers.common.Authorization = `Bearer ${accessTokenAfterExpired}`;
          } else {
            removeLocalStorageItem('RefreshToken');
            removeLocalStorageItem('AccessToken');
            removeLocalStorageItem('role');
            removeLocalStorageItem('SessionId');
            removeLocalStorageItem('UserId');
            window.location.href = '/login';
          }

          return Instance(originalConfig);
        } catch (_error) {
          if (_error?.response?.data) {
            return Promise.reject(_error.response.data);
          }
          return Promise.reject(_error);
        }
      }

      if (err.response.status === 419 && err.response.data) {
        return Promise.reject(err.response.data);
      }
    }

    return Promise.reject(err);
  },
);

export default Instance;
